import { Controller } from "@hotwired/stimulus"

// The Phone page's hours editor (Phone_Settings_Plan.md, Phone_Round2_Plan.md):
// three modes. "Office hours" shows the fine print; "Custom schedule" shows
// the week, where an unchecked day reads Closed; "Always ring" shows
// neither. Any change shows "Unsaved changes" until the form is saved. The
// server renders the same starting state, so the page reads right before
// this connects.
export default class extends Controller {
  static targets = ["week", "day", "times", "closed", "dirty", "finePrint"]

  connect() {
    this.sync()
  }

  changed() {
    this.sync()
    if (this.hasDirtyTarget) this.dirtyTarget.hidden = false
  }

  sync() {
    const mode = this.element.querySelector("input[name='hours_mode']:checked")?.value
    if (this.hasWeekTarget) this.weekTarget.hidden = mode !== "custom"
    if (this.hasFinePrintTarget) this.finePrintTarget.hidden = mode !== "office"
    this.dayTargets.forEach((row) => {
      const open = row.querySelector("input[type='checkbox']")?.checked
      row.querySelectorAll("[data-phone-hours-target='times']").forEach((el) => { el.hidden = !open })
      row.querySelectorAll("[data-phone-hours-target='closed']").forEach((el) => { el.hidden = !!open })
    })
  }
}
